export default {
  xs: '0.75rem',
  sm: '0.875rem',
  md: '1rem',
  lg: '1.5rem',
  xl: '2.2rem',
};
